module.exports = __webpack_public_path__ + "95814d2b.png";